import React, { ForwardedRef, memo, forwardRef } from 'react'
import { Chip, ChipProps } from '@mui/material'
import { Edit } from '@mui/icons-material'

export interface ISkillsInputItemProps extends ChipProps {
  editable: boolean
  open: boolean
  onClick: (e: React.MouseEvent<HTMLElement>) => void
}

const SkillsInputItem = (props: ISkillsInputItemProps, ref: ForwardedRef<HTMLDivElement>) => {
  const { onClick, open, editable, ...restProps } = props

  return (
    <Chip
      {...restProps}
      ref={ref}
      color={open ? 'primary' : undefined}
      icon={editable ? (<Edit style={{ pointerEvents: 'none' }} />) : undefined}
      clickable={editable}
      onClick={editable ? onClick : undefined}
    />
  )
}

export default memo(forwardRef<HTMLDivElement, ISkillsInputItemProps>(SkillsInputItem))
